@if (vm().intro) {
  <p class="hd-emotional-waves__intro">{{ vm().intro }}</p>
}

@for (wave of vm().waves; track wave.key) {
  <section
    class="hd-emotional-waves__wave"
    [class.is-in-chart]="wave.inChart"
    [attr.data-emotional-wave]="wave.key"
    [style.--hd-wave-color]="wave.color"
  >
    <header class="hd-emotional-waves__wave-header">
      <hd-emotional-wave-glyph [wave]="wave.key" size="large" />
      <div class="hd-emotional-waves__wave-heading">
        <h4 class="hd-emotional-waves__wave-name">
          {{ wave.name }}
          @if (wave.inChart) {
            <span class="hd-emotional-waves__badge" data-test-id="emotional-wave-in-chart">{{ vm().inChartLabel }}</span>
          }
        </h4>
        @if (wave.sourceName) {
          <p class="hd-emotional-waves__source-name">{{ wave.sourceName }}</p>
        }
        <p class="hd-emotional-waves__channels">{{ vm().channelsLabel }} {{ wave.channels }}</p>
      </div>
    </header>

    @for (field of wave.fields; track field.key) {
      @if (field.text) {
        <p class="hd-emotional-waves__field" [attr.data-field]="field.key">
          <span class="hd-emotional-waves__field-label">{{ field.label }}:</span>
          {{ field.text }}
        </p>
      }
    }
  </section>
}

<section
  class="hd-emotional-waves__wave hd-emotional-waves__wave--source"
  [class.is-in-chart]="vm().source.inChart"
  data-emotional-wave="source"
  [style.--hd-wave-color]="vm().source.color"
>
  <header class="hd-emotional-waves__wave-header">
    <hd-emotional-wave-glyph wave="source" size="large" />
    <div class="hd-emotional-waves__wave-heading">
      <h4 class="hd-emotional-waves__wave-name">
        {{ vm().source.name }}
        @if (vm().source.inChart) {
          <span class="hd-emotional-waves__badge" data-test-id="emotional-wave-in-chart">{{ vm().inChartLabel }}</span>
        }
      </h4>
      @if (vm().source.sourceName) {
        <p class="hd-emotional-waves__source-name">{{ vm().source.sourceName }}</p>
      }
      <p class="hd-emotional-waves__channels">{{ vm().channelsLabel }} {{ vm().source.channels }}</p>
    </div>
  </header>

  @if (vm().source.description) {
    <p class="hd-emotional-waves__field">{{ vm().source.description }}</p>
  }

  <ul class="hd-emotional-waves__source-lines">
    @for (line of vm().source.lines; track line.wave) {
      <li>
        <hd-emotional-wave-glyph [wave]="line.wave" />
        <span>{{ line.text }}</span>
      </li>
    }
  </ul>
</section>

<section class="hd-emotional-waves__extra" data-emotional-wave="combinations">
  <h4 class="hd-emotional-waves__extra-title">{{ vm().combinationsTitle }}</h4>
  @if (vm().combinationsIntro) {
    <p class="hd-emotional-waves__field">{{ vm().combinationsIntro }}</p>
  }
  <ul class="hd-emotional-waves__combinations">
    @for (combination of vm().combinations; track combination.key) {
      <li [class.is-in-chart]="combination.inChart" [attr.data-combination]="combination.key">
        {{ combination.text }}
        @if (combination.inChart) {
          <span class="hd-emotional-waves__badge">{{ vm().inChartLabel }}</span>
        }
      </li>
    }
  </ul>
</section>

@if (vm().open) {
  <section class="hd-emotional-waves__extra" data-emotional-wave="open">
    <h4 class="hd-emotional-waves__extra-title">{{ vm().openTitle }}</h4>
    <p class="hd-emotional-waves__field">{{ vm().open }}</p>
  </section>
}
